import { render, staticRenderFns } from "./storeDistribution.vue?vue&type=template&id=1dbbdb61&scoped=true&"
import script from "./storeDistribution.vue?vue&type=script&lang=js&"
export * from "./storeDistribution.vue?vue&type=script&lang=js&"
import style0 from "./storeDistribution.vue?vue&type=style&index=0&id=1dbbdb61&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbbdb61",
  null
  
)

export default component.exports